export enum ScheduledPaymentBillingFrequencyEnum {
  MONTHLY = 'MONTHLY',
  EVERY_3MONTH = 'EVERY_3MONTH',
  EVERY_6MONTH = 'EVERY_6MONTH',
  ANNUALLY = 'ANNUALLY',
  SINGLE = 'SINGLE'
}
